<template>
  <svg
    width="13"
    height="12"
    viewBox="0 0 13 12"
  >
    <path d="M5.78783 1.94755C4.51613 0.675856 2.45878 0.669676 1.19258 1.93587C-0.0736098 3.20206 -0.06743 5.25942 1.20426 6.53111L5.91176 11.2386C6.10702 11.4339 6.4236 11.4339 6.61886 11.2386L11.3019 6.55833C12.5651 5.28802 12.5612 3.23643 11.2892 1.96452C10.0153 0.690545 7.95694 0.684364 6.68849 1.95282L6.24122 2.40095L5.78783 1.94755ZM10.5928 5.8532L6.26531 10.1779L1.91137 5.82401C1.02925 4.94189 1.02498 3.51769 1.89969 2.64298C2.77441 1.76826 4.1986 1.77254 5.08072 2.65466L5.89008 3.46401C6.08867 3.66261 6.41184 3.65872 6.6056 3.45539L7.39559 2.65993C8.27257 1.78295 9.69773 1.78723 10.5821 2.67162C11.4645 3.55396 11.4672 4.97391 10.5928 5.8532Z" />
  </svg>
</template>
